import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { z } from 'zod';
import { getMagazineCategoryUseCase } from "../useCases/getMagazineCategoryUseCase";
import { updateMagazineCategoryUseCase } from "../useCases/updateMagazineCategoryUseCase";
import { toastService } from "src/libraries/toast";
import { useUiContext } from "src/UIProvider";
import { magazineCategoryModel } from "../entity/magazineCategory/MagazineCategoryModel";

export const useMagazineCategoryEditing = () => {
    const { t } = useUiContext();
    const id = useParams().id;
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ name: '', description: '' });
    const magazineCategory = magazineCategoryModel.magazineCategory;
    const navigate = useNavigate();

    const magazineCategorySchema = z.object({
        name: z.string().min(1, { message: t('common.error.notEmpty') }),
        description: z.string().min(1, { message: t('common.error.notEmpty') }),
    });

    useEffect(() => {
        getMagazineCategoryUseCase(Number(id));
        return () => { magazineCategoryModel.magazineCategory = null; }
    }, []);

    const onChange = (value: string, field: string) => {
        if (magazineCategoryModel.magazineCategory) {
            magazineCategoryModel.magazineCategory = { ...magazineCategoryModel.magazineCategory, [field]: value };
            setErrors((prev) => ({ ...prev, [field]: '' }));
        }
    };

    const onUpdateMagazineCategory = async () => {
        setLoading(true);
        if (magazineCategoryModel.magazineCategory) {
            const result: any = magazineCategorySchema.safeParse({ 
                name: magazineCategoryModel.magazineCategory.name,
                description: magazineCategoryModel.magazineCategory.description
            });
            
            if (result.success) {
                const response = await updateMagazineCategoryUseCase({
                    id: magazineCategoryModel.magazineCategory.id,
                    name: magazineCategoryModel.magazineCategory.name,
                    description: magazineCategoryModel.magazineCategory.description
                });
                
                if (!response?.isError) {
                    toastService.onSuccess(t('magazineCategory.message.magazineCategoryUpdated'));
                    navigate(`/dashboard/magazine-categories`);
                }
            } else {
                result.error.errors.map((item: any) => {
                    setErrors((prev) => ({ ...prev, [item.path[0]]: item.message }));
                });
            }
        }
        setLoading(false);
    };

    return { magazineCategory, errors, onChange, onUpdateMagazineCategory, loading };
};